export default __webpack_public_path__ + "static/media/mirror.b6755f6a.svg";